import { TableColumn } from "../pages/ListReceipt";

export const columns: TableColumn[] = [
  { key: "activity", header: "Activity"},
  { key: "memberName", header: "Member Name"},
  { key: "access_id", header: "Access Id"},
  { key: "email", header: "Corporate Email"},
  { key: "suntecEmail", header: "Suntec+ Email"},
  { key: "mobile", header: "Mobile"},
  { key: "createdDate", header: "Created Date"},
];

export const metaData = {
  voucherNo: {
    isImage: false,
    linkTo: "",
  },
  amount: {
    isImage: false,
    linkTo: "",
  },
  soldTo: {
    isImage: false,
    linkTo: "",
  },
  issueDate: {
    isImage: false,
    linkTo: "",
  },
  expiryDate: {
    isImage: false,
    linkTo: "",
  },
  createdDate: {
    isImage: false,
    linkTo: "",
  },
  type: {
    isImage: false,
    linkTo: "",
  },
  remarks: {
    isImage: false,
    linkTo: "",
  },
  voucherUsed: {
    isImage: false,
    linkTo: "",
  },
  merchantName: {
    isImage: false,
    linkTo: "",
  },
  mode: {
    isImage: false,
    linkTo: "",
  },
};
